import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-asp-coupon-discount-popup',
  templateUrl: './asp-coupon-discount-popup.component.html',
  styleUrls: ['./asp-coupon-discount-popup.component.scss']
})
export class AspCouponDiscountPopupComponent implements OnInit {

  constructor(
    public dialog:MatDialogRef<AspCouponDiscountPopupComponent>,
  ) { }

  ngOnInit(): void {
    
  }

  closePopup(){
    this.dialog.close();
  }

}
